import { useField } from 'formik';
import type { ChangeEventHandler, ReactNode } from 'react';
import React from 'react';

import type { TextFieldProps } from '../textInput/TextField.tsx';
import TextField from '../textInput/TextField.tsx';

export type CardNumberInputProps = {
  name: string;
  value: string;
  onChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  maxLength: number;
} & TextFieldProps;

const CardNumberInput = (props: CardNumberInputProps): ReactNode => {
  const { value, onChange, maxLength, ...rest } = props;
  const [cardNumberField, , cardNumberHelper] = useField(props.name);

  const handleCreditCardNumberChange = (event) => {
    let value = event.target.value;

    value = value.replace(/[^0-9]/g, '');

    value = value.replace(/(\d{4})/g, '$1 ');

    value = value.trim();
    cardNumberHelper.setValue(value);
  };

  return (
    <TextField
      value={cardNumberField.value}
      onChange={handleCreditCardNumberChange}
      autoComplete='cc-number'
      fullWidth
      required
      inputProps={{
        maxLength: 19,
        pattern: '[0-9]*',
        inputMode: 'numeric',
      }}
      {...rest}
    />
  );
};

export default CardNumberInput;
